import React from 'react'
import RenderProfilePicture from '../../../../_helpers/profile-picture'
import { Card, Row, Col } from 'react-bootstrap'

export default function UserCard({firstName, lastName, credentials, profileImage, publicIdentity, children}) {
  const handleProfileImage = () => {
    if (profileImage) {
      return publicIdentity ? profileImage : "https://s3.amazonaws.com/axs.images/assets/profile5.png"
    }
    return "https://s3.amazonaws.com/axs.images/assets/profile5.png"
  }

  return (
    <Card className='axs-rounded font-weight-light mt-2' 
      style={{ minWidth: '300px', maxWidth: '500px', border: '1px solid RGB(240, 240, 240)'}}
    >
      <Card.Body>
        <Row>
          <Col xs='auto'>
            <RenderProfilePicture height={45} width={45} image={handleProfileImage()} circle cached={false} className='m-auto' />
          </Col>
          <Col>
            <Row>
              <Col>
                {firstName ? 
                  <span>{firstName}</span> : 
                  <span className='font-italic'>Firstname</span>
                }
                &nbsp;
                {lastName ? 
                  <span>{publicIdentity ? lastName : `${lastName[0]}.`}</span> : 
                  <span className='font-italic'>Lastname</span>
                }
                ,&nbsp;
                {credentials ? 
                  <span>{credentials}</span> : 
                  <span className='font-italic'>Credentials</span>
                }
              </Col>
            </Row>
            { children }
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}
